<template>
  <div class="equipments">
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column column is-full">
            <b-button v-if="(!is_template && currentUserAccess('EquipmentDetails', this.UserActions.CREATE, this.project_id))
                            || (is_template && currentUserAccess('ProjectTemplates', this.UserActions.CREATE))" 
                      class="button is-primary" icon-left="plus-thick" @click="addNewEquipmentClicked">
              {{ $t('equipments-view.new-equipment-button') }}
            </b-button>
            <b-table class="equipments-table" :data="equipmentsData" :striped="true" :hoverable="false"
                     :mobile-cards="true" :loading="isLoading" :scrollable="true">
              <b-table-column field="equipment.model" :label="this.$t('equipments-view.equipment-model-column')" v-slot="props" searchable sortable>
                <router-link :to="{ name: 'EquipmentDetails', params: { project_id:project_id, equipment_id:props.row.equipment.document_id, is_template: is_template }}">
                  {{ getAdjustedTitle(props.row.equipment.model) }}
                </router-link>
              </b-table-column>
              <b-table-column field="equipment.category" :label="this.$t('equipments-view.equipment-category-column')"
                              v-slot="props" searchable sortable>
                {{ props.row.equipment.category }}
              </b-table-column>
              <b-table-column field="equipment.provider" :label="this.$t('equipments-view.equipment-provider-column')"
                              v-slot="props" searchable sortable>
                {{ props.row.equipment.provider }}
              </b-table-column>
              <b-table-column field="equipment.meta.estimation.quantity" :label="this.$t('equipments-view.equipment-quantity-column')"
                              v-slot="props" width="10%" sortable>
                {{ getFormattedQuantityEquipment(props.row.equipment.meta.estimation, props.row.equipment.unit) }}
              </b-table-column>
              <b-table-column field="equipment.meta.estimation.fee_per_unit" :label="this.$t('equipments-view.equipment-fee-per-unit-column')"
                              v-slot="props" width="10%" sortable>
                {{ getFormattedFeePerUnit(props.row.equipment.meta.estimation) }}
              </b-table-column>
              <b-table-column field="equipment.meta.estimation.expected_total_fee" :label="this.$t('equipments-view.equipment-total-fee-column')"
                              v-slot="props" width="10%" sortable>
                {{ getFormattedPricing(props.row.estimation.expected_total_fee) }}
              </b-table-column>
              <b-table-column field="text" :label="this.$t('equipments-view.equipment-text-column')" v-slot="props" width="22%">
                {{ truncateColumn(props.row.equipment.text) }}
              </b-table-column>
            </b-table>
          </div>
        </div>
      </div>
      <b-modal
          :width="640"
          v-model="isModalActive"
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-modal>
        <template #default="props">
          <EquipmentDetails v-bind:project_id="project_id" v-bind:equipment_id="'new'" @close="props.close"
                            @equipmentAdded="readEquipmentsData"></EquipmentDetails>
        </template>
      </b-modal>
    </section>
  </div>
</template>

<script>
import EquipmentDetails from "@/components/EquipmentDetails";
import firebase from "firebase/app";

export default {
  name: "Equipments",
  components: {
    EquipmentDetails
  },
  props: {
    'project_id': {
      type: String,
    },
    'is_template': {
      type: Boolean,
    }
  },
  data() {
    return {
      equipmentsData: [],
      isLoading: false,
      isModalActive: false
    }
  },
  methods: {
    readEquipmentsData: function () {
      this.isModalActive = false;
      this.isLoading = true;
      this.equipmentsData = [];
      const functions = firebase.app().functions("europe-west3");
      const getEquipmentsFunction = functions.httpsCallable(this.getSubmitEndpoint());
      console.log("project_id: ", this.project_id);
      getEquipmentsFunction({action: "get_equipments", project_id: this.project_id, fill_meta: true})
          .then((result) => {
            console.log("equipment list result: ", result.data);
            if (result.data.equipments.length > 0) {
              result.data["equipments"].forEach((equipment) => {
                this.equipmentsData.push({
                  equipment: equipment,
                  estimation: equipment.meta.estimation ? equipment.meta.estimation : {}
                });
              });
            }
          })
          .catch((error) => {
            this.showError(error.message)
            console.log("Error getting equipments: ", error);
          });
      this.isLoading = false;
    },
    /*
     UI Events
     */
    addNewEquipmentClicked: function () {
      this.isModalActive = true;
    }
  },
  mounted() {
    this.readEquipmentsData();
  }
};
</script>

<style scoped>
.equipments-table {
  margin-top: 16px;
}
</style>
